<template>
	<insurance-apply datum :id="id"></insurance-apply>
</template>

<script>
	import insuranceApply from './insurance_apply.vue'
	
	export default {
		components: {
			insuranceApply
		},
		
		props: {
			id: String
		}
	}
</script>